// The numbers behind the Progress tab (Kenny and Cassidy, 2026-11-02). Pure, no DB.
// A workout counts once it's finished; warm-ups don't count; timed holds have no weight to compare.

const DONE = new Set(['completed', 'madeup']);
const parse = (iso) => { const [y, m, d] = iso.split('-').map(Number); return new Date(y, m - 1, d); };
const fmt = (dt) => `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
export const addDays = (iso, n) => { const dt = parse(iso); dt.setDate(dt.getDate() + n); return fmt(dt); };

export function personStats({ sessions = [], sets = [], library = [], today }) {
  const finished = sessions.filter((s) => DONE.has(s.status));
  const dateOf = new Map(finished.map((s) => [s.id, s.date]));
  const liftOf = new Map(library.map((x) => [x.id, x]));
  const days = [...new Set(finished.map((s) => s.date))].sort();
  const weekStart = addDays(today, -6);

  const work = sets.filter((s) => !s.is_warmup && dateOf.has(s.session_id));
  let volume7 = 0;
  const topByLift = new Map(); // exercise id -> Map(date -> heaviest weight that day)
  for (const s of work) {
    const w = Number(s.weight_lb);
    const lift = liftOf.get(s.exercise_id);
    if (!(w > 0) || lift?.tracking === 'time') continue;
    const date = dateOf.get(s.session_id);
    if (date >= weekStart && date <= today) volume7 += w * (Number(s.reps) || 0);
    if (!topByLift.has(s.exercise_id)) topByLift.set(s.exercise_id, new Map());
    const top = topByLift.get(s.exercise_id);
    top.set(date, Math.max(top.get(date) || 0, w));
  }

  // A lift needs two different days before it can say anything about progress.
  const gains = [...topByLift.entries()].filter(([, top]) => top.size >= 2).map(([id, top]) => {
    const series = [...top.entries()].sort((a, b) => (a[0] < b[0] ? -1 : 1));
    const first = series[0][1];
    const last = series[series.length - 1][1];
    return { id, exercise: liftOf.get(id) || { id, name: 'Lift' }, first, last, change: last - first, pct: Math.round((last / first - 1) * 100), series };
  }).sort((a, b) => b.change - a.change || a.exercise.name.localeCompare(b.exercise.name));

  return {
    days,
    workouts7: days.filter((d) => d >= weekStart && d <= today).length,
    volume7: Math.round(volume7),
    heavier: gains.filter((g) => g.change > 0).length,
    gains,
    last14: Array.from({ length: 14 }, (_, i) => { const date = addDays(today, i - 13); return { date, on: days.includes(date) }; }),
  };
}

// You and Cass side by side, in percent, because each person is measured against their own start.
export function togetherStats(a, b) {
  const together = a.days.filter((d) => b.days.includes(d));
  const theirs = new Map(b.gains.map((g) => [g.id, g]));
  const shared = a.gains.filter((g) => theirs.has(g.id)).map((g) => ({ id: g.id, exercise: g.exercise, a: g, b: theirs.get(g.id) }))
    .sort((x, y) => Math.max(y.a.pct, y.b.pct) - Math.max(x.a.pct, x.b.pct) || x.exercise.name.localeCompare(y.exercise.name));
  return { together: together.length, since: together[0] || null, shared };
}
